<template>
     <div v-for="(v,index) in ledger_arr" track-by="$Index" class="ml-0">
      
            <!-- Ledger Card Starts -->
            <div id="ledgers" class="ledger_allocation">
                <h6 class="yellow-section " style="background-color: #e0f1fc">
                    <span class="voucher-label">{{ledger_key}}</span>
                    <span><button id="LEDGERENTRIES_delete_button"
                            @click="delete_element(index)"
                            class="inventory-submit-btn ml-1" style="float:right;"
                            type="submit">-</button></span>
                    <span><button @click="billallocation(v)" style="float:right;"
                            type="submit"
                            class="inventory-submit-btn ml-1">Bills</button></span>
                    <span><button @click="bankallocation(v)" style="float:right;"
                            type="submit"
                            class="inventory-submit-btn">Banks</button></span>
                </h6>
                <div class="">
                      <div class="m-1"> 
                          <div>
                               <div class="dx-field ">
                                <div class="dx-field-label">LEDGER NAME:</div>
                                   <div class="dx-field-value grid grid-cols-2 gap-4">
                                            <div>
                                                 <DxSelectBox
                                                     @value-changed="handleValueChange($event)" 
                                                    :data-source="Headers_cust"
                                                    :value="v.LEDGERNAME"
                                                    :accept-custom-value="true"
                                                    v-model:selectedItem="v.LEDGERNAME"
                                                 />
                                            </div>
                                            <div>
                                                <DxSelectBox
                                                    style="display:none;"
                                                    :data-source="ledger_names"
                                                    v-model:visible ="selectboxVisiblity"
                                                 />
                                            </div>
                                   </div>
                                </div>
                                <div class="dx-field">
                                    <div class="dx-field-label">AMOUNT:</div>
                                    <div class="dx-field-value">
                                        <DxSelectBox :data-source="Headers_roundOff " 
                                        :value="v.AMOUNT"
                                        :accept-custom-value="true"
                                        v-model:selectedItem="v.AMOUNT"
                                        />
                                    </div>
                                </div>
                                <div class="dx-field">
                                    <div class="dx-field-label">ISDEEMEDPOSITIVE:</div>
                                        <div class="dx-field-value">
                                            <DxSelectBox 
                                                :items="is_deemed_positive1"
                                                :value="v.ISDEEMEDPOSITIVE"
                                                :accept-custom-value="true"
                                                v-model:selectedItem="v.ISDEEMEDPOSITIVE"
                                            />
                                        </div>
                                </div>
                                <div class="dx-field">
                                <div class="dx-field-label">ISPARTYLEDGER:</div>
                                    <div class="dx-field-value">
                                        <DxSelectBox 
                                            :items="is_party_ledger"
                                            :value="v.ISPARTYLEDGER"
                                            :accept-custom-value="true"
                                            v-model:selectedItem="v.ISPARTYLEDGER"
                                        />
                                    </div>
                                </div>
                          </div> 
                    </div>
                </div>  
                <div v-for="(v1,k1) in v " track-by="$Index">
                    <div v-if="k1=='BILLALLOCATIONS'">
                        <!-- BillAllocation starts -->
                        <billallocation :is_party_ledger1="is_party_ledger1" :is_deemed_positive1="is_deemed_positive1" :bill_allocation_arr="v1" :bill_allocation_key="k1" :Headers="Headers" />
                        <!-- <billallocation :is_party_ledger="is_party_ledger" :is_deemed_positive="is_deemed_positive" :bill_allocation_arr="v1" :bill_allocation_key="k1" :Headers="Headers" /> -->
                        <!-- BillAllocation ends -->
                    </div>
                    <div v-if="k1=='BANKALLOCATIONS'">
                        <!-- BANKAllocation starts -->
                        <bankallocation :is_party_ledger1="is_party_ledger1" :is_deemed_positive1="is_deemed_positive1" :bank_allocation_arr="v1" :bank_allocation_key="k1" :Headers="Headers" />
                        <!-- <bankallocation :is_party_ledger="is_party_ledger" :is_deemed_positive="is_deemed_positive" :bank_allocation_arr="v1" :bank_allocation_key="k1" :Headers="Headers" /> -->
                        <!-- BANKAllocation ends -->
                    </div>
                </div>
            </div>
            <!-- Ledger Card ends -->
        </div>
</template>
<script>
import bankallocation from './bankallocation'
import billallocation from './billallocation'
import DxSelectBox from 'devextreme-vue/select-box';
export default {
    name:'ledgerentry',
    components:{
        bankallocation,
        billallocation,
         DxSelectBox,
    },
    data: function() {
        return {
           custom_value:["--CUSTOM--"], 
           roundoff_value:["*Roundoff"],
        //    is_deemed_positive1:[{"Yes":"DR"},{"No":"CR"}],  
            is_party_ledger:[ "Yes", "No"],
           // added new varible
           selectboxVisiblity:false,
        }
    },
    props:{
        ledger_arr:{
          type:Array,
          default: {}
        },
        Headers:{
          type:Array,
          default: {}
        },
        ledger_names:{
          type:Array,
          default: {}
        },
        is_deemed_positive1:{
          type:Array,
          default: {}
        },
        is_deemed_positive:{},
        // is_party_ledger:{},
        // is_party_ledger1:{
        //   type:Array,
        //   default: {}
        // },
        ledger_key:'',
        Headers_cust:{
          type:Array,
          default: {}
        },
        Headers_roundOff:{
          type:Array,
          default: {}
        }, 
    },
    methods:{
        billallocation(value){
            this.$emit('billallocation',value)
        },
        bankallocation(value){
            this.$emit('bankallocation',value)
        },
        delete_element(index){
            this.ledger_arr.splice(index,1)
        },

        // Select combobox  new code added------///
        handleValueChange(e){
                e.element.parentElement.childNodes[1].style.display = "block";
    },
    },
    mounted(){
    }
}
</script>

<style >
/* .ledger_allocation{
  margin-left: -25px;
}
.card-body{
     margin-left: 20px;   
}  */
/* .ledger{
    margin-left: 110px;
    width: 310px;
} */
.name{
     margin-left: 8rem; 
    margin-right:5rem ;
  }
  @media (max-width: 640px) {
 .font{
     font-size: 11px;
 }  
 }
</style>